import { z } from 'zod'

import { AdUnitForPageTransferList } from 'features/inventory/page/forms/GeneralForm/hooks/useGetAdUnitsForPageTransferList/adUnitForPageTransferList'
import { PageForGeneralForm } from '../hooks/useGetPage'
import { isRefreshControlledByYb } from '../utils'
import { adUnitIdsField } from './adUnitIdsField'
import { commonSchema } from './commonSchema'

export const editSchema = z
  .object({
    id: z.string(),
  })
  .extend(adUnitIdsField.shape)
  .extend(commonSchema.shape)

export type EditSchema = z.infer<typeof editSchema>

export const editSchemaDefault = (page: PageForGeneralForm): EditSchema => {
  const {
    adUnits,
    customVariableName,
    customVariableTriggerEnabled,
    customVariableValue,
    domain: { id: domainId, overriddenByYieldbird, pubAdsServiceRefresh },
    id,
    matchType,
    name,
    onlySendAdRequestsForAssignedAdUnits,
    path,
    pathTriggerEnabled,
  } = page

  const refreshControlledByYb: boolean = isRefreshControlledByYb({
    overriddenByYieldbird,
    pubAdsServiceRefresh,
  })

  return {
    adUnitIds: mapAdUnitsToForm(adUnits),
    customVariableName: customVariableName ?? '',
    customVariableTriggerEnabled,
    customVariableValue: customVariableValue ?? '',
    domainId: domainId,
    id,
    matchType: matchType ?? 'include',
    name,
    onlySendAdRequestsForAssignedAdUnits: refreshControlledByYb
      ? onlySendAdRequestsForAssignedAdUnits
      : false,
    path: path ?? '',
    pathTriggerEnabled,
  }
}

const mapAdUnitsToForm = (adUnits: AdUnitForPageTransferList[]): EditSchema['adUnitIds'] =>
  adUnits.map(
    (adUnit: AdUnitForPageTransferList): AdUnitForPageTransferList['value'] => adUnit.value,
  )
